var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPdf = function SvgIconPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65107 0C8.32404 0 7.23828 1.125 7.23828 2.5V37.5C7.23828 38.875 8.32404 40 9.65107 40H33.779C35.106 40 36.1918 38.875 36.1918 37.5V10L26.5406 0H9.65107Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9538 10H36.1922L26.541 0V7.5C26.541 8.875 27.6268 10 28.9538 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1915 17.5L28.9531 10H36.1915V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 32.5C31.3656 33.1875 30.8227 33.75 30.1592 33.75H3.6185C2.95499 33.75 2.41211 33.1875 2.41211 32.5V20C2.41211 19.3125 2.95499 18.75 3.6185 18.75H30.1592C30.8227 18.75 31.3656 19.3125 31.3656 20V32.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67188 23.6837C7.67188 23.3537 7.9228 22.9937 8.32695 22.9937H10.5552C11.8098 22.9937 12.939 23.8637 12.939 25.5312C12.939 27.1112 11.8098 27.9912 10.5552 27.9912H8.94462V29.3112C8.94462 29.7512 8.67439 29.9999 8.32695 29.9999C8.00846 29.9999 7.67188 29.7512 7.67188 29.3112V23.6837ZM8.94462 24.2524V26.7424H10.5552C11.2018 26.7424 11.7133 26.1512 11.7133 25.5312C11.7133 24.8324 11.2018 24.2524 10.5552 24.2524H8.94462Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.828 29.9997C14.5096 29.9997 14.1621 29.8197 14.1621 29.381V23.7035C14.1621 23.3447 14.5096 23.0835 14.828 23.0835H17.0369C21.4451 23.0835 21.3486 29.9997 17.1238 29.9997H14.828ZM15.4361 24.3035V28.781H17.0369C19.6416 28.781 19.7574 24.3035 17.0369 24.3035H15.4361Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9123 24.3838V25.9725H25.3721C25.7196 25.9725 26.067 26.3325 26.067 26.6813C26.067 27.0113 25.7196 27.2813 25.3721 27.2813H22.9123V29.38C22.9123 29.73 22.6722 29.9988 22.3344 29.9988C21.9098 29.9988 21.6504 29.73 21.6504 29.38V23.7025C21.6504 23.3438 21.911 23.0825 22.3344 23.0825H25.7208C26.1454 23.0825 26.3963 23.3438 26.3963 23.7025C26.3963 24.0225 26.1454 24.3825 25.7208 24.3825H22.9123V24.3838Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1598 33.75H7.23828V35H30.1598C30.8233 35 31.3662 34.4375 31.3662 33.75V32.5C31.3662 33.1875 30.8233 33.75 30.1598 33.75Z",
    fill: "#CAD1D8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pdf.5baef227.svg";
export { ForwardRef as ReactComponent };